import { render, staticRenderFns } from "./addVehicleStaff.vue?vue&type=template&id=46898bc0"
import script from "./addVehicleStaff.vue?vue&type=script&lang=js"
export * from "./addVehicleStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports